import React, { RefObject } from "react";
import { Pressable } from "react-native";
import { View } from "native-base";
import TopButton from "../../TopNavigator/Buttons/TopButton";
import { verticalScale_ } from "../../../Universal/API/Scale";
import { handleExpandedMenu } from "../../TopNavigator/ExpandedMenu/utils";
import { option } from "../interfaces";
import { useSmartNavigate } from "../../../Universal/API/Context-API/hooks/useSmartNavigate";
import { useUserState } from "../../../Universal/API/Context-API/hooks/useUserState";

interface ServiceProps {
  refExpandedMenu: RefObject<null | handleExpandedMenu>;
  navigation: any;
  hover?: {
    onPanelHoverIn: () => void;
    onPanelHoverOut: () => void;
  };
}

const Service: React.FC<ServiceProps> = ({ refExpandedMenu, navigation, hover }) => {

  const { formServiceProps } = useFormServiceProps({ navigation });
  const sericeProps = React.useMemo(() => {
    return formServiceProps({ refExpandedMenu });
  }, [formServiceProps, refExpandedMenu]);
  return (
    <Pressable
      onHoverIn={hover?.onPanelHoverIn}
      onHoverOut={hover?.onPanelHoverOut}
      style={{ justifyContent: "center", alignItems: "center", flex: 1 }}
    >
      <View
        alignItems={"flex-start"}
        flexDirection={"column"}
        style={{ gap: verticalScale_(10) }}
      >
        {sericeProps.map((option, index) => {
          return (
            <View key={`${option.text}-${index}`}>
              <TopButton text={option.text} 
              
              addBottomLine={false} onPress={option.onPress}
               onHoverIn={() => hover?.onPanelHoverIn?.()}
                // onHoverOut={() => hover?.onPanelHoverOut?.()}
              />
            </View>
          );
        })}
      </View>
    </Pressable>
  );
};


export const useFormServiceProps = ({ navigation }: { navigation: any }) => {
  const { smartNavigate } = useSmartNavigate({ navigation });
  const { isUserLoggedIn } = useUserState();

  const formServiceProps = ({
    refExpandedMenu,
    close,
  }: {
    refExpandedMenu?: RefObject<null | handleExpandedMenu>;
    close?: () => void;
  } = {}) => {
    const close_ = () => {
      if (close) close();
    };

    return [
      {
        text: "Аккаунт",
        onPress: () => {
          refExpandedMenu?.current?.close();
          smartNavigate({ navigation, goTo: "Account", data: {} });
          close_();
        },
      },
      {
        text: "Каталоги",
        onPress: () => {
          refExpandedMenu?.current?.close();
          smartNavigate({ navigation, goTo: "Catalogs", data: {} });
          close_();
        },
      },
      {
        text: "Лицензии и Сертификаты",
        onPress: () => {
          refExpandedMenu?.current?.close();
          smartNavigate({ navigation, goTo: "LicensesAndCertificates", data: {} });
          close_();
        },
      },
      {
        text: "Инструкции по монтажу",
        onPress: () => {
          refExpandedMenu?.current?.close();
          smartNavigate({ navigation, goTo: "InstructionsBuild", data: {} });
          close_();
        },
      },
      {
        text: "Сервис Центр",
        onPress: () => {
          refExpandedMenu?.current?.close();
          smartNavigate({ navigation, goTo: "ServiceCenter", data: {} });
          close_();
        },
      },
      ...(isUserLoggedIn
        ? [
            {
              text: "История заказов",
              onPress: () => {
                refExpandedMenu?.current?.close();
                smartNavigate({
                  navigation,
                  goTo: "Cart",
                  data: {
                    history: true,
                  },
                });
                close_();
              },
            },
          ]
        : []),
      {
        text: "Видео - помощь по монтажу",
        onPress: () => {
          refExpandedMenu?.current?.close();
          close_();
        },
      },
    ] as option[];
  };

  return { formServiceProps };
};

export default Service;
